import { useState } from 'react';
import { createPortal } from 'react-dom';
import { fmtMoney, useT } from '../../lib/i18n';
import { MethodPicker, methodLabel, useMethod, type PayMethod } from '../../components/MethodPicker';

/**
 * «+ Кредит»: money handed over, turned into credits at the client's rate
 * (routes/coach.ts, topup). The amount, and how it was paid (sql/040) —
 * once a prompt, which had no room for the second question.
 */
export function TopUpSheet({ onClose, onSave }: { onClose: () => void; onSave: (amount: number, method: PayMethod) => Promise<void> }) {
  const t = useT();
  const [value, setValue] = useState('80');
  const [method, setMethod] = useMethod();
  const [busy, setBusy] = useState(false);
  const amount = Number(value.replace(',', '.'));
  return createPortal(
    <div className="sheet" onClick={onClose}>
      <div className="sheet__panel" onClick={(e) => e.stopPropagation()}>
        <div className="sheet__title">{t('co.cd.topUpPrompt')}</div>
        <label className="field" style={{ marginTop: 12 }}>
          <span className="field__input">
            <input type="number" inputMode="decimal" value={value} autoFocus
              onChange={(e) => setValue(e.target.value)} />
            <em>€</em>
          </span>
        </label>
        <MethodPicker value={method} onChange={setMethod} />
        <div className="sheet__actions">
          <button className="paybar__opt" onClick={onClose}>{t('co.pkg.back')}</button>
          <button className="savebtn" disabled={busy || !(amount > 0)}
            onClick={async () => { setBusy(true); try { await onSave(amount, method); } finally { setBusy(false); } }}>
            {t('pm.with', { action: t('co.paid.btn', { amount: amount > 0 ? fmtMoney(amount) : '' }), method: methodLabel(t, method) })}
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
}
